export const t = { "en": { "placeholder": "placeholder" } };
export const d = [require("foundations-components/lang/en.lyaml")];